import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useContext, useState } from 'react';
import classnames from 'classnames';
import { NavigationContext } from "../../../context/navigation.context";
import { defaultThemeContext } from "../../../context/theme.context";
import { PrimaryMenuSubNav } from "../../Navigation/PrimaryMenuSubNav/PrimaryMenuSubNav";
import { Button } from "../../Button/Button/Button";
import { Theme } from "../../Background/Theme/Theme";
import { Container } from "../../Container/Container/Container";
import { PrimaryMenu } from "../../Navigation/PrimaryMenu/PrimaryMenu";
import { SecondaryMenu } from "../../Navigation/SecondaryMenu/SecondaryMenu";
import { MobileMenuSlideout } from "../../Navigation/MobileMenuSlideout/MobileMenuSlideout";
import { Image } from "../../Image/Image/Image";
import styles from "./NavigationSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavigationSlice = function NavigationSlice(_ref) {
  var _logo$icon, _logo$icon2, _logo$icon2$desktop, _logo$icon2$desktop$s, _logo$icon3, _logo$icon3$desktop, _logo$icon4, _logo$icon4$desktop, _logo$icon5;
  var closeLabel = _ref.closeLabel,
    closeSubMenuLabel = _ref.closeSubMenuLabel,
    cta = _ref.cta,
    _ref$compactSize = _ref.compactSize,
    compactSize = _ref$compactSize === void 0 ? false : _ref$compactSize,
    _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? {
      label: '',
      url: '',
      icon: {
        desktop: {
          source: {
            url: '',
            xml: ''
          },
          height: '',
          width: '',
          format: 'svg'
        },
        mobile: {
          source: {
            url: '',
            xml: ''
          },
          height: '',
          width: '',
          format: 'svg'
        }
      }
    } : _ref$logo,
    openLabel = _ref.openLabel,
    openSubMenuLabel = _ref.openSubMenuLabel,
    _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? [] : _ref$primary,
    primaryMobile = _ref.primaryMobile,
    _ref$primaryMenuSubNa = _ref.primaryMenuSubNavItems,
    primaryMenuSubNavItems = _ref$primaryMenuSubNa === void 0 ? [] : _ref$primaryMenuSubNa,
    _ref$secondary = _ref.secondary,
    secondary = _ref$secondary === void 0 ? [] : _ref$secondary,
    secondaryMobile = _ref.secondaryMobile,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? true : _ref$sticky,
    _ref$reducedNav = _ref.reducedNav,
    reducedNav = _ref$reducedNav === void 0 ? false : _ref$reducedNav;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileOpen = _useState2[0],
    setMobileOpen = _useState2[1];
  var handleOpen = function handleOpen() {
    setMobileOpen(true);
  };
  var handleClose = function handleClose() {
    setMobileOpen(false);
  };
  var isPrimarySubNav = (primaryMenuSubNavItems === null || primaryMenuSubNavItems === void 0 ? void 0 : primaryMenuSubNavItems.length) > 0;
  var isSecondaryMenu = (secondary === null || secondary === void 0 ? void 0 : secondary.length) > 0;
  var isPrimaryMenu = (primary === null || primary === void 0 ? void 0 : primary.length) > 0;
  var navigationContext = useContext(NavigationContext);
  var ctaButtonType = navigationContext.transparent && navigationContext.theme !== defaultThemeContext ? 'secondary' : 'primary';
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('webview', {
      [styles.background]: !navigationContext.transparent,
      [styles.sticky]: sticky,
      [styles.mobileOpen]: mobileOpen
    }),
    "data-e2e-name": "navigation_slice",
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: /*#__PURE__*/_jsxs(Theme, {
          theme: navigationContext.transparent ? navigationContext.theme : defaultThemeContext,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.containerLeft,
            children: [/*#__PURE__*/_jsx(Button, {
              accessibilityLabel: logo === null || logo === void 0 ? void 0 : logo.label,
              type: "no-style",
              url: logo === null || logo === void 0 ? void 0 : logo.url,
              className: classnames(styles.logoLink, {
                [styles.logoNoUrl]: !(logo !== null && logo !== void 0 && logo.url),
                [styles.logoFocusState]: logo === null || logo === void 0 ? void 0 : logo.url
              }),
              "data-e2e-name": "navigation_slice_logo_link",
              disabled: !(logo !== null && logo !== void 0 && logo.url),
              children: (logo === null || logo === void 0 ? void 0 : (_logo$icon = logo.icon) === null || _logo$icon === void 0 ? void 0 : _logo$icon.desktop) && /*#__PURE__*/_jsx(Image, {
                src: (logo === null || logo === void 0 ? void 0 : (_logo$icon2 = logo.icon) === null || _logo$icon2 === void 0 ? void 0 : (_logo$icon2$desktop = _logo$icon2.desktop) === null || _logo$icon2$desktop === void 0 ? void 0 : (_logo$icon2$desktop$s = _logo$icon2$desktop.source) === null || _logo$icon2$desktop$s === void 0 ? void 0 : _logo$icon2$desktop$s.url) || '',
                width: (logo === null || logo === void 0 ? void 0 : (_logo$icon3 = logo.icon) === null || _logo$icon3 === void 0 ? void 0 : (_logo$icon3$desktop = _logo$icon3.desktop) === null || _logo$icon3$desktop === void 0 ? void 0 : _logo$icon3$desktop.width) || '100%',
                height: (logo === null || logo === void 0 ? void 0 : (_logo$icon4 = logo.icon) === null || _logo$icon4 === void 0 ? void 0 : (_logo$icon4$desktop = _logo$icon4.desktop) === null || _logo$icon4$desktop === void 0 ? void 0 : _logo$icon4$desktop.height) || '40px',
                className: styles.logo,
                loading: "eager"
              })
            }), /*#__PURE__*/_jsx("nav", {
              className: classnames(styles.primaryWrapper, reducedNav && styles.reducedNav),
              "data-e2e-name": "navigation_slice_primary_wrapper",
              children: primary && /*#__PURE__*/_jsx(PrimaryMenu, {
                primaryMenuItems: primary,
                compactSize: compactSize
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.containerRight,
            children: [isSecondaryMenu && /*#__PURE__*/_jsx("div", {
              className: classnames(styles.secondaryWrapper, reducedNav && styles.reducedNav),
              children: /*#__PURE__*/_jsx(SecondaryMenu, {
                menuItems: secondary,
                compactSize: compactSize
              })
            }), cta && /*#__PURE__*/_jsx(Button, {
              attributes: cta.attributes,
              type: ctaButtonType,
              url: cta.url,
              className: styles.cta,
              size: 'small',
              children: cta.text
            }), (isPrimaryMenu || isSecondaryMenu) && /*#__PURE__*/_jsx("div", {
              className: classnames(styles.mobileWrapper, reducedNav && styles.reducedNav),
              children: /*#__PURE__*/_jsx(MobileMenuSlideout, {
                menuItems: {
                  primary: primaryMobile || primary,
                  secondary: secondaryMobile || secondary
                },
                cta: cta,
                closeLabel: closeLabel,
                closeSubMenuLabel: closeSubMenuLabel,
                openLabel: openLabel,
                openSubMenuLabel: openSubMenuLabel,
                logo: logo !== null && logo !== void 0 && (_logo$icon5 = logo.icon) !== null && _logo$icon5 !== void 0 && _logo$icon5.mobile ? {
                  icon: logo.icon.mobile,
                  label: logo.label || '',
                  url: logo.url || ''
                } : undefined,
                onOpen: handleOpen,
                onClose: handleClose
              })
            })]
          })]
        })
      })
    }), isPrimarySubNav && /*#__PURE__*/_jsx(PrimaryMenuSubNav, {
      primaryMenuSubNavItems: primaryMenuSubNavItems || []
    })]
  });
};